// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"fc3e087b","279":"6cf22651","485":"64b5e1bd","511":"c10d13ec","639":"e98011d0","652":"9e94398a","686":"2d784538","687":"14647e96","787":"c4e7f8f9","874":"c9d7bda1"}[chunkId] + ".chunk.js";
};